import {
  FETCH_LOGO_BRANDS_SUCCESS,
  FETCH_LOGO_BRANDS_ERROR,
  SAVE_LOGO_BRANDS_SUCCESS,
  SAVE_LOGO_BRANDS_ERROR,
  DELETE_LOGO_BRANDS_SUCCESS,
  DELETE_LOGO_BRANDS_ERROR,
  GET_LOGO_BRANDS_SUCCESS,
} from 'actionTypes'

const DEFAULT_STATE = {
  logoBrandsList: [],
  success: '',
  error: null,
  counter: 0,
  logoBrands: [],
  getUpdate: false,
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_LOGO_BRANDS_SUCCESS:
      if (state.counter < action.counter || action.counter === 0) {
        return {
          ...state,
          logoBrandsList: action.payload,
          success: '',
          error: null,
          counter: action.counter,
          getUpdate: false,
        }
      }
      return { ...state }
    case SAVE_LOGO_BRANDS_SUCCESS:
      return {
        ...state,
        success: 'datasheetManagement.save.success',
        error: null,
        getUpdate: false,
      }
    case GET_LOGO_BRANDS_SUCCESS:
      return {
        ...state,
        logoBrands: action.payload,
        success: '',
        error: null,
        getUpdate: true,
      }
    case DELETE_LOGO_BRANDS_SUCCESS:
      return {
        ...state,
        success: 'datasheetManagement.delete.success',
        error: null,
        getUpdate: false,
      }
    case FETCH_LOGO_BRANDS_ERROR:
    case SAVE_LOGO_BRANDS_ERROR:
    case DELETE_LOGO_BRANDS_ERROR:
      return { ...state, success: '', error: action.payload, getUpdate: false }
    default:
      return { ...state, success: '' }
  }
}
